exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Lists-45c6071d .demoBox-bd19a93d{background:#f5f5f5;padding:20px;margin:0 0 30px 0;position:relative}\n", ""]);

// Exports
exports.locals = {
	"Lists": "Lists-45c6071d",
	"demoBox": "demoBox-bd19a93d"
};